<template>
    <div class="industry-structure">
        <dataTop :Width='Width'/>
        <h2>承租人行业结构分析</h2>
        <industry-category @currentChange='currentChange'></industry-category>
        <container class="table-box">
            <div class="search">
                <span>{{form.lesseeIndustry}}
                    <i>{{total}}租户</i>
                </span>
                <el-form :form="form" inline>
                    <el-form-item label="租户名称：">
                        <el-input v-model='form.lessee' placeholder="请输入租户名称" style="width: 180px"/>
                    </el-form-item>
                    <el-form-item label="资产产权证地址：">
                        <el-input v-model='form.assetAddressDetail' placeholder="请输入资产产权证地址" style="width: 180px"/>
                    </el-form-item>
                    <el-form-item label="异常内容：">                
                        <el-select placeholder='请选择' v-model='form.warningType' style="width: 140px">
                            <el-option label="全部" value=""></el-option>
                            <el-option label="无异常" value="0"></el-option>
                            <el-option label="经营异常" value="1"></el-option>
                            <el-option label="工商信息变更" value="2"></el-option>
                            <el-option label="失信被执行人" value="4"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" style="margin-right:10px;" @click="searchHandle" :loading='loading'>
                        查询
                        </el-button>
                    </el-form-item>
                    <el-form-item label="">
                        <el-select v-model='form.assetCompanyId' placeholder="请选择" style="width: 140px">
                            <el-option
                                v-for="item in unitOptions"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <div class="table">
                <el-table
                    :data="dataList"
                    stripe
                    style="width: 100%;
                    background-color:#061033;">
                    <el-table-column
                        prop="key"
                        min-height="80"
                        label="序号">
                    </el-table-column>
                    <el-table-column
                        prop="lessee"
                        label="租户">
                    </el-table-column>
                    <el-table-column
                        prop="legalPerson"
                        label="法人">
                    </el-table-column>
                    <el-table-column
                        prop="lesseeIndustry"
                        label="行业分类">
                    </el-table-column>
                    <el-table-column
                        prop="warningFlag"
                        label="出现预警">
                        <template slot-scope="scope">
                            <span v-if="scope.row.warningFlag">是</span>
                            <span v-else>否</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="warningcontent"
                        label="异常内容">
                    </el-table-column>
                    <el-table-column
                        prop="assetAddressDetail"
                        label="租赁资产地址">
                    </el-table-column>
                    <el-table-column
                        prop="managementEnterprise"
                        label="资产管理单位名称">
                    </el-table-column>
                    <el-table-column
                        prop="address"
                        label="操作">
                        <template slot-scope="scope">
                            <el-button  type="text" @click="checkHandle(scope.row)" style="color:#fff;">查看</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="page">
                <el-pagination
                    background
                    layout="total,slot, prev, pager, next"
                    :page-size="10"
                    :current-page='form.page'
                    @current-change='handleTableChange'
                    :total="total">
                    <span class="page-left">第{{form.page}}/{{NumberDiv(total,10)}}页</span>
                </el-pagination>
            </div>
        </container>
    </div>
</template>
<script>
import dataTop from "../index/components/dataTop";
import container from "../index/components/container";
import industryCategory from './industryCategory.vue'
import {structureList} from "../../../api/bigDataContract.js";
import {getCompanyList} from '../../../api/contract.js'
export default {
    name:'industryStructure',
    data(){
        return{
            Width: 0,
            unitOptions:[],
            total: 0,
            loading: false,
            form:{
                lessee:'',
                assetAddressDetail:'',
                lesseeIndustry:'',
                warningType:'',
                assetCompanyId:-1,
                page:1,
                perPage: 10,
            },
            dataList:[],
        }
    },
    components:{
        industryCategory,
        dataTop,
        container
    },
    methods:{
        getWindowWidth() {
            this.Width = window.innerWidth
        },
        NumberDiv (arg1,arg2){
            var pages=arg1%arg2==0?(arg1/arg2):(Math.floor(arg1/arg2)+1);
            return Number(pages);
        },
        checkHandle(params){
            let status = 1
            if(params.tenantType == 'PERSONAL'){
                status = 0
            }else if(params.tenantType == 'ENTERPRISE'){
                status = 1
            }
            let routeData = this.$router.resolve({path:'/tenantManagement/tenantDetail',query:{broadside:params.lessee,status:status,contractId:params.id,assetCompanyId:params.assetCompanyId}})
            window.open(routeData.href, '_blank');
        },
        handleTableChange(page){
            this.form.page=page;
            this.getList();
        },
        currentChange(item){
            this.form.lesseeIndustry = item.name
            this.getList();
        },
        getCompanyList(){
            getCompanyList().then(res => {
                let data = res.data
            if (data.code === '000') {
                this.unitOptions = data.content.list
            } else {
                this.unitOptions = []
            }
            }).catch(err => {
                console.log(err);
            })
        },
        searchHandle(){
            this.form.page = 1
            this.getList();
        },
        getList() {
            let para=Object.assign({},this.form)
            if(para.lesseeIndustry == '全部'){
                para.lesseeIndustry = ''
            }
            this.loading = true;
            structureList(para).then(res => {
                this.loading = false
                let data = res.data
                if (data.code === '000') {
                    let arr = data.content.list
                    for (let i in arr){
                        arr[i].key = Number(i)+1
                        if(!arr[i].warningFlag){
                            arr[i].warningcontent = '无异常'
                        }else{
                            if(arr[i].warningType == '1'){
                                arr[i].warningcontent = '经营异常'
                            }else if(arr[i].warningType == '2'){
                                arr[i].warningcontent = '工商信息变更'
                            }else if(arr[i].warningType == '4'){
                                arr[i].warningcontent = '失信被执行人'
                            }
                        }
                        
                    }
                    this.dataList = arr
                    this.total = data.content.total
                } else {
                    this.dataList = []
                    this.total = 0
                }
            }).catch(err => {
                this.loading = false
                console.log(err);
            }).finally(() => {
                this.loading = false
            })
        },
    },
    created() {
      this.getCompanyList()
      if(this.$route.query.name){
        this.form.lesseeIndustry = this.$route.query.name
        this.getList()
      }
      if(this.$route.query.companyId) {
        this.form.assetCompanyId = this.$route.query.companyId
        this.form.assetCompanyId = Number(this.form.assetCompanyId)
        this.getList()
      }

      
    },
    mounted() {
      this.getWindowWidth()
      window.addEventListener('resize', this.getWindowWidth)
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.getWindowWidth)
    }
}
</script>
<style lang="scss">
.industry-structure{
    min-height: 100vh;
    .el-form-item > label {
        color: #fff;
    }
    .el-input__inner::placeholder{
        color:#fff;
        font-size:12px;
    }
    .el-form-item__content .el-button{
        background-color:#0A56C5;
        border-color:#0A56C5;
        margin-left: 10px;
        margin-right: 10px;
    }
    .el-input__inner{
        background-color:transparent;
        border-radius:4px;
        border:1px solid rgba(29,62,143,1);
        box-shadow:0px 0px 6px 2px rgba(17,24,110,1);
        margin-right:10px;
        color:#fff;
        font-size:12px;
        .el-select{
            background-color:transparent;
            color:#fff;
        }
    }
    .table{
        .el-table thead > tr > th{
            color:#06FBEC;
            background-color:#1D3E8F;
            border-bottom:none;
            padding: 13px 16px;
        }
        .el-table tbody tr > td{
            background-color:#061033;
            border-color:#1D3E8F;
            padding: 13px 16px;
            color:#fff;
        }
        tr {
            background-color:transparent!important;
        }
        .el-table tbody tr:active {
            background-color:#1D3E8F!important;
        }
        .el-table::before {
            background-color:#1D3E8F;
        }
        .el-table__empty-block {
            background-color:#061033;
            color:#fff;
        }
    }
    .ant-table-pagination.ant-pagination{
      margin-right: 10px;
    }
    .ant-table-placeholder{
        background-color:transparent;
        border:0;
        .ant-empty-normal{
            color:#6FA9FB;
        }

    }
    .page {
        margin-top:40px;
        text-align:right;
        .el-pagination__total{
            color:#fff;
            float: left;
        }
        .page-left{
            font-weight: 400;
            color:#fff;
            float: left;
        }
        .el-pagination .btn-prev {
            color:#606266;          
            background: #FFFFFF !important;
            border-radius: 2px;
        }
        .el-pagination .btn-next {
            color:#606266;          
            background: #FFFFFF !important;
            border-radius: 2px;
        }
        .el-pager li {
            color:#606266;          
            background: #FFFFFF !important;
            border-radius: 2px;
        }
        .el-pager li.active {
            background: #0A56C5 !important;
            color:#fff !important;
            border-radius: 2px;
        }
    }
}
</style>

<style lang="scss" scoped>
.industry-structure{
    color:#fff;
    padding: 0 15px 15px;
    background-color: #061033;
    min-height: 100vh;
    width: 100%;
    .top{
        display:flex;
        justify-content: space-between;
        align-items: center;
        h1{
            font-weight: 600;
            font-size:20px;
            color:#fff;
        }
        span{
            cursor: pointer;
            font-size:12px;
        }
        .refresh{
            cursor: pointer;
            span{
                vertical-align: middle;
            }
            img{
                vertical-align: middle;
            }
        }

    }
    h2{
        color:#fff;
        margin:15px 0;
        font-size:24px;
    }
    .table-box{
        background-color:#061033;
        padding:15px 30px;
        margin-top:15px;
        .search{
            padding:0 10px;
            display: flex;
            span {
                margin-top: 8px;
            }
            h4{
                color:#B8D7FF;
                font-size:16px;
                margin:0;
            }
            i{
                color:#FF464B;
                font-size:16px;
                padding:0 10px;
            }
        }
        .table{
            margin-top:15px;
        }
    }
}
</style>


